<template>
    <div class="site__body">
        <div class="block-space block-space--layout--after-header"></div>
        <div class="block">
            <div class="container container--max--xl">
                <div class="row">
                    <account-navigation active-page="return-list"></account-navigation>
                    <return-panel></return-panel>
                </div>
            </div>
        </div>
        <div class="block-space block-space--layout--before-footer"></div>
    </div>
</template>

<script>
import AccountNavigation from '../accountnavigation/AccountNavigation';
import ReturnPanel from './ReturnPanel';
// import axiosvl from "../../../axios/axios-vl.js";

export default {
    name: 'ReturnList',
    components: {
        AccountNavigation,
        ReturnPanel    
    },

    data() {
        return {
            rmalist: [],
        }
    },

    methods: {
    },

    created() {
        
    }
}
</script>